import { Helmet } from 'react-helmet-async';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';

export default function Terms() {
  return (
    <div className="min-h-screen bg-slate-950">
      <Helmet>
        <title>Terms of Service | SquareCount</title>
        <meta name="description" content="SquareCount terms of service for our roof measurement software platform." />
        <link rel="canonical" href="https://squarecount.io/terms" />
        <meta name="robots" content="noindex" />
      </Helmet>
      <Navbar />

      <section className="bg-gradient-to-br from-slate-900 via-slate-800 to-orange-900 text-white py-20">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="font-heading font-black text-4xl sm:text-5xl mb-4">Terms of Service</h1>
          <p className="text-slate-300">Last updated: February 8, 2026</p>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-6 py-16">
        <div className="prose prose-lg prose-invert max-w-none">
          <h2 className="font-heading font-bold text-2xl text-white">1. Acceptance of Terms</h2>
          <p className="text-slate-300">By accessing or using SquareCount, you agree to be bound by these Terms of Service and our Privacy Policy. If you do not agree, do not use our services.</p>

          <h2 className="font-heading font-bold text-2xl text-white mt-8">2. Service Description</h2>
          <p className="text-slate-300">SquareCount provides satellite-based roof measurement and material estimation services for roofing contractors. We offer:</p>
          <ul className="text-slate-300">
            <li>Free tier: 3 measurements per month</li>
            <li>Pro tier: Unlimited measurements for $19/month</li>
            <li>Contractor tier: Pro features plus team access for $79/month</li>
            <li>One-time report packs</li>
          </ul>

          <h2 className="font-heading font-bold text-2xl text-white mt-8">3. Accuracy and Use</h2>
          <p className="text-slate-300">While we strive for 98%+ accuracy, SquareCount measurements are estimates. You agree to:</p>
          <ul className="text-slate-300">
            <li>Verify measurements on-site when necessary</li>
            <li>Use measurements as estimates, not guarantees</li>
            <li>Not rely solely on our measurements for critical decisions</li>
            <li>Understand that satellite imagery may be outdated</li>
          </ul>

          <h2 className="font-heading font-bold text-2xl text-white mt-8">4. Account Responsibilities</h2>
          <p className="text-slate-300">You are responsible for:</p>
          <ul className="text-slate-300">
            <li>Maintaining the confidentiality of your account</li>
            <li>All activities that occur under your account</li>
            <li>Notifying us of any unauthorized access</li>
            <li>Providing accurate information</li>
          </ul>

          <h2 className="font-heading font-bold text-2xl text-white mt-8">5. Payment Terms</h2>
          <ul className="text-slate-300">
            <li><strong className="text-white">Subscriptions:</strong> Billed monthly, auto-renew until cancelled</li>
            <li><strong className="text-white">Free Tier:</strong> Resets on the 1st of each month</li>
            <li><strong className="text-white">Refunds:</strong> Prorated refunds available within 30 days</li>
            <li><strong className="text-white">Payment Processing:</strong> Handled securely by Stripe</li>
          </ul>

          <h2 className="font-heading font-bold text-2xl text-white mt-8">6. Cancellation</h2>
          <p className="text-slate-300">You may cancel your subscription at any time. Upon cancellation:</p>
          <ul className="text-slate-300">
            <li>You will retain access until the end of the billing period</li>
            <li>Your account will downgrade to the free tier</li>
            <li>Unused report credits will expire</li>
            <li>Measurement history will be retained for 90 days</li>
          </ul>

          <h2 className="font-heading font-bold text-2xl text-white mt-8">7. Prohibited Uses</h2>
          <p className="text-slate-300">You may not:</p>
          <ul className="text-slate-300">
            <li>Resell or redistribute our services</li>
            <li>Use automated tools to scrape our data</li>
            <li>Reverse engineer our platform</li>
            <li>Share your account with others (except team features)</li>
            <li>Use the service for illegal purposes</li>
          </ul>

          <h2 className="font-heading font-bold text-2xl text-white mt-8">8. Intellectual Property</h2>
          <p className="text-slate-300">SquareCount and its original content, features, and functionality are owned by SquareCount and are protected by international copyright, trademark, and other intellectual property laws.</p>

          <h2 className="font-heading font-bold text-2xl text-white mt-8">9. Limitation of Liability</h2>
          <p className="text-slate-300">SquareCount shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of the service.</p>

          <h2 className="font-heading font-bold text-2xl text-white mt-8">10. Changes to Terms</h2>
          <p className="text-slate-300">We may modify these terms at any time. Continued use of SquareCount after changes constitutes acceptance of the new terms.</p>

          <h2 className="font-heading font-bold text-2xl text-white mt-8">11. Contact</h2>
          <p className="text-slate-300">For questions about these Terms, contact us at:</p>
          <p className="text-slate-300"><strong className="text-white">Email:</strong> legal@squarecount.io</p>
        </div>
      </section>
      <Footer />
    </div>
  );
}
